export default __webpack_public_path__ + "static/facilities-img3-48fa69d02b241970846afc43308f139c.png";